module.exports = __webpack_public_path__ + "img/375_stores_img6.c066449a.png";